<template>
  <ReCruiseModal :showModal="showModal" @update:showModal="updateShowModal">
    <template #header="{ closeModal }">
      <div class="modal-header">
        <div></div>

        <div class="modal-title">{{ $t('panstarPay.panstarPay') }}</div>

        <button class="close-button" @click="closeModal">
          <img src="@/assets/images/icon/close_icon.svg" alt="icon" />
        </button>
      </div>
    </template>

    <template #content>
      <div class="panstar-pay-container">
        <template v-if="!isApp">
          <div class="mileage-wrapper">
            <div class="total-mileage-wrapper">
              <div class="total-mileage-title">{{ $t('panstarPay.availableMileage') }}</div>
              <div class="total-mileage">
                {{ convertCommaNumber(mileage) }}{{ $i18n.locale !== 'ja' ? $t('currency.krw') : $t('currency.jpy') }}
              </div>
            </div>

            <div class="mileage-chip">{{ $t('panstarPay.miles5Percent') }}</div>
          </div>

          <div class="divider"></div>
        </template>

        <!-- <ReCruiseButton class="history-btn" theme="normal" @click="">
          {{ $t('panstarPay.purchaseHistory') }}
        </ReCruiseButton>

        <div class="divider"></div> -->

        <div class="payment-method-wrapper">
          <div class="payment-method-title">{{ $t('panstarPay.myCards') }}</div>

          <ReCruiseButton class="register-btn" theme="normal" @click="goToStep('register')">
            <PlusCircle class="plus-icon" :size="20" />
            <span> {{ $t('panstarPay.addCard') }} </span>
          </ReCruiseButton>

          <div
            class="card-wrapper"
            :class="selectedClass(card)"
            v-for="card in cardList"
            :key="card.billKey"
            @click="changeMainCard(card)"
          >
            <div class="card-info-wrapper">
              <div class="card-info">
                <div class="card-title-wrap">
                  <span class="card-company">{{ card.issuerName }}</span>

                  <span v-if="card.category === 'PANSTAR_PAY'" class="register-path-chip" :class="selectedClass(card)">
                    {{ $t('panstarPay.registerWebApp') }}
                  </span>
                  <span v-else class="register-path-chip" :class="selectedClass(card)">
                    {{ $t('panstarPay.registerKiosk') }}
                  </span>
                </div>
                <span class="masked-card-number">{{ convertCardNumber(card.cardMaskNo) }}</span>
                <ReCruiseRadio
                  class="card-radio"
                  :modelValue="selectedBillKey"
                  :label="$t('panstarPay.useForOnboard')"
                  :value="card.billKey"
                />
              </div>
            </div>

            <DeleteOutline
              v-if="card.category === 'PANSTAR_PAY'"
              class="delete-icon"
              :size="24"
              @click.stop="deleteCard(card)"
            />
          </div>
        </div>
      </div>
    </template>

    <template #button>
      <ReCruiseButton class="close-btn-pc" theme="outline" @click="updateShowModal(false)">
        {{ $t('actions.close') }}
      </ReCruiseButton>
      <ReCruiseButton class="close-btn-mobile" @click="updateShowModal(false)">
        {{ $t('actions.close') }}
      </ReCruiseButton>
    </template>
  </ReCruiseModal>
</template>

<script>
import { mapState } from 'vuex';
import { convertCommaNumber } from '@/utils/convert';

import PaymentService from '@/services/payment';
import MileageService from '@/services/mileage';
import PanstarPayService from '@/services/neoHelios/cruise/panstarPay';

import PlusCircle from 'vue-material-design-icons/PlusCircle';
import DeleteOutline from 'vue-material-design-icons/DeleteOutline';

import ReCruiseModal from '@/components/renewal/modal/ReCruiseModal.vue';
import ReCruiseButton from '@/components/renewal/button/ReCruiseButton.vue';
import ReCruiseRadio from '@/components/renewal/common/ReCruiseRadio.vue';

export default {
  name: 'PanstarPayModal',
  components: { ReCruiseModal, ReCruiseButton, PlusCircle, DeleteOutline, ReCruiseRadio },
  props: {
    showModal: { type: Boolean, required: true },
    goToStep: Function,
    cardList: Array,
  },
  data() {
    return {
      step: 'panstarPay',
      selectedBillKey: '',
      mileage: 0,
    };
  },
  computed: {
    ...mapState('auth', ['user']),

    userId() {
      return this.user?.userId;
    },
    isApp() {
      return this.$route.fullPath.includes('app');
    },
  },
  watch: {
    cardList: {
      immediate: true,
      handler() {
        this.cardList.forEach(card => {
          if (card.isInVesselPurchase) {
            this.selectedBillKey = card.billKey;
          }
        });
      },
    },
  },
  methods: {
    convertCommaNumber,
    updateShowModal(value) {
      this.$emit('update:showModal', value);
    },
    selectedClass(card) {
      return {
        selected: this.selectedBillKey === card.billKey,
      };
    },
    convertCardNumber(cardNumber) {
      if (cardNumber.length !== 16) return cardNumber;

      const group1 = cardNumber.substring(0, 4);
      const group2 = cardNumber.substring(4, 8);
      const group3 = cardNumber.substring(8, 12);
      const group4 = cardNumber.substring(12, 16);

      return `${group1} - ${group2} - ${group3} - ${group4}`;
    },
    async changeMainCard(card) {
      if (this.selectedBillKey === card.billKey) return;

      // 선내 결제용 카드 변경 API 호출
      try {
        this.selectedBillKey = card.billKey;
        const token = this.$route.query.token;
        const params = { billKey: card.billKey };

        await PanstarPayService.selectPaymentCardOnBoard(params, token);
      } catch (error) {
        this.$alert({ content: error });
      }
    },
    async deleteCard(card) {
      const result = await this.$confirm({
        title: this.$t('panstarPay.deleteCardConfirm'),
        content: this.$t('panstarPay.cardDeleteWarning'),
      });
      if (!result) return;

      // 카드 삭제 API 호출
      try {
        const token = this.$route.query.token;
        const params = {
          mallId: card.mallId,
          billKey: card.billKey,
        };

        await PaymentService.deletePanstarPayBillKey(params, token);
        this.$emit('onDeleteCard');
      } catch (error) {
        this.$alert({ content: error });
      }
    },
    async getUserMileage() {
      if (!this.user || this.isApp) return;

      try {
        const { data } = await MileageService.getUserMileage();
        this.mileage = data.mileage;
      } catch (error) {
        this.$alert({ content: error });
      }
    },
  },
  created() {
    this.getUserMileage();
  },
};
</script>

<style scoped>
.modal-header {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  color: var(--Grey-grey-900, #333);
  font-family: 'Pretendard';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.panstar-pay-container {
  color: var(--Grey-grey-700, #686d72);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: var(--Grey-grey-100, #dddfe2);
}

.mileage-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 8px;
}

.total-mileage-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.total-mileage-title {
  color: var(--Grey-grey-900, #333);
  font-family: 'Pretendard';
  font-size: 18px;
  font-weight: 600;
}

.total-mileage {
  color: var(--Blue-blue-500, #446ceb);
  font-family: 'Pretendard';
  font-size: 32px;
  font-weight: 700;
  height: 38px;
}

.mileage-chip {
  padding: 5px 15px;
  width: fit-content;
  height: 27px;
  display: inline-block;

  color: var(--Blue-blue-500, #446ceb);
  font-family: 'Pretendard';
  font-size: 14px;
  font-weight: 500;

  border-radius: 30px;
  border: 1px solid var(--Blue-blue-500, #446ceb);
}

.history-btn {
  width: 100%;
}

.payment-method-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.payment-method-title {
  color: var(--Grey-grey-900, #333);
  font-family: 'Pretendard';
  font-size: 18px;
  font-weight: 600;
}

.register-btn {
  width: 100%;
  padding: 24px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 68px;
}

.plus-icon {
  color: var(--Blue-blue-500, #446ceb);
}

.card-wrapper {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid var(--Grayscale-Gray250, #dae0e3);
  cursor: pointer;
}

.card-wrapper.selected {
  border-radius: 10px;
  outline-offset: -2px;
  outline: 2px solid var(--Blue-blue-500, #446ceb);
}

.card-info-wrapper {
  height: 100%;
  flex: 1 0;
  display: flex;
  gap: 16px;
}

.card-info {
  flex: 1 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: var(--Grey-grey-700, #686d72);
}

.card-title-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
}

.card-company {
  padding-top: 2px;
  color: var(--Grey-grey-900, #333);
  font-family: 'Pretendard';
  font-size: 16px;
  font-weight: 600;
}

.register-path-chip {
  padding: 3px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  font-family: 'Pretendard';
  font-size: 11px;
  font-weight: 500;
  color: var(--Grayscale-Gray700, #677680);
  border: 1px solid var(--Grayscale-Gray700, #677680);
}

.register-path-chip.selected {
  color: var(--SEABLUE-SEABLUE, #5175f9);
  border: 1px solid var(--SEABLUE-SEABLUE, #5175f9);
}

.card-radio {
  pointer-events: none;
}

.delete-icon {
  cursor: pointer;
}

.close-btn-pc {
  display: none;
}

.close-btn-mobile {
  width: 100%;
  border-radius: 0;
}

/* pc */
@media screen and (min-width: 768px) {
  .close-btn-mobile {
    display: none;
  }

  .close-btn-pc {
    display: initial;
  }
}
</style>
